// Countdown per i banner di preordine
document.querySelectorAll('[data-countdown]').forEach((el) => {
  const cells = el.querySelectorAll('span');

  const tick = () => {
    let n = Math.max(0, new Date(el.dataset.countdown) - Date.now());
    let d = Math.floor(n / 864e5);
    let h = Math.floor(n / 36e5) % 24;
    let m = Math.floor(n / 6e4) % 60;

    [d, h, m].forEach((v, i) => {
      cells[i].firstChild.nodeValue = String(v).padStart(2, '0');
    });
  };

  tick();
  setInterval(tick, 60000);
});

// Apertura/chiusura menu mobile
document.querySelector('.nav-toggle')?.addEventListener('click', () => {
  document.querySelector('.nav').classList.toggle('open');
});

// Modale di accesso account
(() => {
  const modal = document.getElementById('AccountModal');
  if (!modal) return;

  const open = () => {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    setTimeout(() => modal.querySelector('input')?.focus(), 60);
  };

  const close = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  };

  document.querySelectorAll('[data-account-open]').forEach((b) => {
    b.addEventListener('click', open);
  });

  modal.querySelectorAll('[data-account-close]').forEach((b) => {
    b.addEventListener('click', close);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
})();
